export enum LoginAnalyticsEnum {
  LOGIN_VIEW_MODAL = '[PAC WEB] Login - Modal visualizada',
  LOGIN_CLICK_SUBMIT = '[PAC WEB] Login - Clicou em "Entrar"',
  LOGIN_SUCCESS = '[PAC WEB] Login - Login com sucesso',
  LOGIN_ERROR = '[PAC WEB] Login - Erro de login',
  LOGIN_INVALID_CPF = '[PAC WEB] Login - CPF inválido',
  LOGIN_INVALID_PASSWORD = '[PAC WEB] Login - Senha inválida',
  LOGIN_CLICK_FORGOT_PASSWORD = '[PAC WEB] Login - Clicou em "Esqueci minha senha"',
  LOGIN_CLICK_REGISTER = '[PAC WEB] Login - Clicou em "Cadastre-se"',
  LOGIN_CLOSE_MODAL = '[PAC WEB] Login - Fechou modal',
}

export enum LoginErrorType {
  CREDENCIAIS_INVALIDAS = 'credenciais_invalidas',
  SERVIDOR = 'servidor',
}

export enum LoginOriginEnum {
  HEADER = 'header',
  HELP_CENTER = 'help_center',
  ENTITY = 'entity',
  PASSWORD_RECOVERY = 'password_recovery',
  SEARCH_RESULT = 'search_result',
}
